import { Injectable } from '@angular/core';
import { BaseStoreService } from '@src/app/modules/base';

import { LoyaltyProgramProduct } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class LpFavoriteProductsStoreService extends BaseStoreService<LoyaltyProgramProduct[]> {}
